module.exports = __webpack_public_path__ + "static/media/education.77aeadc3.svg";